// extracted by mini-css-extract-plugin
export var base = "FooterMobile-module--base--26ce4";
export var callToAction = "FooterMobile-module--call-to-action--4088c";
export var logoGrid = "FooterMobile-module--logo-grid--55a84";
export var menu = "FooterMobile-module--menu--04c53";
export var newsletter = "FooterMobile-module--newsletter--70f4b";
export var twitterButton = "FooterMobile-module--twitterButton--9a943";